import storage from "localforage";

export async function storeUser(user, token) {
  return await Promise.all([
    storage.setItem("user", user),
    storage.setItem("token", token)
  ]);
}

export async function getToken() {
  return await storage.getItem("token");
}

export async function getUser() {
  return await storage.getItem("user");
}

export async function clearUser() {
  return await Promise.all([
    storage.removeItem("user"),
    storage.removeItem("token")
  ]);
}

export async function cacheResponse(
  callName,
  data,
  append = false,
  key = null
) {
  if (append) {
    let cache = (await retreiveCachedResponse(callName)) || [];
    if (key) {
      if (Array.isArray(data)) {
        data.map(d => !cache.find(c => c[key] === d[key]) && cache.push(d));
      } else {
        if (!cache.find(c => c[key] === data[key])) {
          cache.push(data);
        }
      }
    } else {
      cache.push(data);
    }
    data = cache;
  }

  console.log("caching", callName, data);
  return await storage.setItem(callName, data);
}

export async function retreiveCachedResponse(callName) {
  console.log("retreiving cached", callName);
  const cache = await storage.getItem(callName);
  return cache || [];
}

export async function getSavedForms() {
  const savedForms = (await storage.getItem("savedForms")) || [];
  return savedForms;
}

export async function removeSavedForm(title) {
  let savedForms = await getSavedForms();
  savedForms = savedForms.filter(form => form.title !== title);
  await storage.setItem("savedForms", savedForms);
}



// WEBPACK FOOTER //
// ./src/backend/storage.js